import * as React from 'react'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
// import { updateUserState } from '../../../store/user'
import config from '../../../config'
import axiosInstant from '../../../api'

export default function BrandSettings(props) {
    const ValidationSchema = Yup.object().shape({
        email: Yup.string().email('Invalid email').required('This field is required'),
    })

    const handleChangePassword = (values) => {
        const params = {
            emailAddress: values.email,
        }

        axiosInstant
            .patch(`${config.API_URL}/users/me`, params)
            .then((response) => {
                toast.success('Email changed succesfully')
                // dispatch(updateUserState(getTokenValue))
            })
            .catch((error) => {
                toast.error('Ooops! Something went wrong')
            })
    }
    return (
        <Formik
            initialValues={{
                email: '',
            }}
            validationSchema={ValidationSchema}
            onSubmit={(values) => {
                handleChangePassword(values)
            }}
        >
            {({ errors, touched }) => (
                <Form className="w-full">
                    <Field
                        placeholder="New Email"
                        name="email"
                        type="text"
                        className={`appearance-none text-sm border rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3 ${
                            errors.email && touched.email ? 'border-error' : 'border-border-token'
                        }`}
                    />
                    {errors.email && touched.email ? (
                        <div className="text-left text-error text-xs font-bold mt-1 pl-5">{errors.email}</div>
                    ) : null}

                    <button
                        className="bg-accent text-base text-white mt-12 py-3 px-5 lg:px-10 block rounded-xl focus:outline-none focus:shadow-outline"
                        type="submit"
                    >
                        Save changes
                    </button>
                </Form>
            )}
        </Formik>
    )
}
